import React from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { useWatch } from 'react-hook-form'
import ClientSelect from './../form_components/ClientSelect';
import OfficerSelect from './../form_components/OfficerSelect';
import SiteSelect from './../form_components/SiteSelect';

const ReportFilterFactory = ({ control, register, errors }) => {
    // Watch the selected report from the ReportSelector 
    const selectedReport = useWatch({
        control,
        name: 'report_type', 
    });

    // if no report is selected, show nothing 
    if (!selectedReport || !selectedReport.parameters) {
        return null;
    }

    const renderFilter = (param) => {
        // Logic to get error for specific nested field: filters.paramName
        const fieldError = errors.filters?.[param];

        switch (param) {
            case 'clientId':
                return (
                    <Col md={4} key={param}>
                        <Form.Label className='small fw-bold'>Client</Form.Label>
                        <ClientSelect
                            name="filters.clientId"
                            control={control}
                            rules={{ required: 'Please select a client'}}
                        />
                        {fieldError && (
                            <div className="text-danger small mt-1">{fieldError.message}</div>
                        )}
                    </Col>
                );

            case 'siteId':
                return (
                    <Col md={4} key={param}>
                        <Form.Label className='small fw-bold'>Site</Form.Label>
                        <SiteSelect
                            name='filters.siteId'
                            control={control}
                            rules={{ required: 'Please select a site'}}
                        />
                        {fieldError && (
                            <div className="text-danger small mt-1">{fieldError.message}</div>
                        )}
                    </Col>
                );

            case 'officerId':
                return (
                    <Col md={4} key={param}>
                        <Form.Label className='small fw-bold'>Security Officer</Form.Label>
                        <OfficerSelect
                            name='filters.officerId'
                            control={control}
                            rules={{ required: 'Please select a security officer'}}
                        />
                        {fieldError && (
                            <div className="text-danger small mt-1">{fieldError.message}</div>
                        )}
                    </Col>
                );

            case 'startDate':
            case 'endDate':
                const label = param === 'startDate' ? 'Start Date' : 'End Date';
                return (
                    <Col md={4} key={param}>
                        <Form.Label className='small fw-bold'>{label}</Form.Label>
                        <Form.Control
                            type='date'
                            {...register(`filters.${param}`, {required: `${label} is required`})}
                            isInvalid={!!fieldError}
                        />
                        <Form.Control.Feedback type='invalid'>
                            {fieldError?.message}
                        </Form.Control.Feedback>
                    </Col>
                );

            default: 
                // Fallback for generic text parameters 
                return (
                    <Col md={4} key={param}>
                        <Form.Label className='small fw-bold text-capitalize'>
                            {param.replace('_', ' ')}
                        </Form.Label>
                        <Form.Control
                            type='text'
                            {...register(`filters.${param}`, { required: 'This field is required'})}
                            isInvalid={!!fieldError}
                        />
                        <Form.Control.Feedback type='invalid'>
                            {fieldError?.message}
                        </Form.Control.Feedback>
                    </Col>
                )
        }
    }
  return (
    <div className="bg-light p-3 rounded-border mb-4">
        <h6 className="text-muted mb-3">Report Filters</h6>
        <Row className='g-3'>
            {selectedReport.parameters.map(parameter => renderFilter(parameter))}
        </Row>
    </div>
  )
}

export default ReportFilterFactory